import { render, staticRenderFns } from "./ModuleCalendar.vue?vue&type=template&id=49669d75&"
import script from "./ModuleCalendar.vue?vue&type=script&lang=js&"
export * from "./ModuleCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports